const BASE_URL = "https://webservice-rsx4vrb4cq-ew.a.run.app/api"

export default BASE_URL
